// src/data/projects/descriptions.js
export const projectDescriptions = {
    portfolio: [
        'A modern, responsive portfolio website built with React.js and Sass. It features smooth animations, a dark mode toggle, and showcases my projects and skills effectively.',
        'Wondering why this is one of my best? Check out the project live, then explore the codebase to see the clean structure and best practices implemented.',
        'Examine the version-controlled GitHub repository as well and assess my readiness for Collaborative Development.',
    ],
    bonmart: [
        'An enterprise-grade "Green E-commerce" platform built with Next.js 15 (App Router) and React 19. It showcases a high-performance architecture utilizing Redux Toolkit 2.0 with normalized state (createEntityAdapter) to achieve O(1) data lookup efficiency.',
        'The system features URL-driven state synchronization for optimal SEO, memoized selectors to ensure referential stability and zero-waste re-renders, and a scalable design system using Tailwind CSS v4 design tokens.',
        'Engineered with strict TypeScript for total type safety, it demonstrates professional mastery of server-side rendering, concurrent UI transitions, and robust state persistence layer management.'
    ],
    yummyRecipes: [
        'An application for discovering, exploring, and managing meal recipes.',
        'Users can search by ingredient or name and get detailed cooking instructions, as well as save their favorite recipes, demonstrating proficiency in API handling and state management.'
    ],
    qrCode: [
        'A utility app for generating and downloading QR codes from user-provided text or URLs.',
        'It features a simple, intuitive user interface and instant QR code generation, built with a strong focus on user experience (UX).'
    ],
    githubProfile: [
        'A tool for searching and viewing GitHub user profiles and their public repositories.',
        'It utilizes the GitHub API to fetch and display user data in a clean, interactive interface, showcasing effective asynchronous data handling.'
    ],
    movieSearch: [
        'A responsive web application that allows users to search for movies using a third-party API.',
        'It features real-time search functionality and displays detailed information about each movie, demonstrating enhanced user interaction and API integration.'
    ],
    legacyPortfolio: [
        'My initial attempt at building a portfolio website, using React.js and SCSS.',
        'This project demonstrates foundational skills in component-based architecture, state management, and basic styling. Comparing it to my current portfolio highlights my significant growth in modern design practices, code quality, and performance optimization.'
    ],
    nextjsDashboard: [
        'A dynamic, feature-rich dashboard built with Next.js.',
        'It showcases server-side rendering (SSR) and static site generation (SSG) capabilities, effectively demonstrating proficiency in modern full-stack development and robust data management.'
    ],
    contactManager: [
        'A simple contact management system that allows users to add, view, and delete contacts.',
        'This project is a practical demonstration of routing, advanced state management, and local storage integration.'
    ],
};
